import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const ValueWrapper = styled.div`
  font-size: ${pxToRem('40px')};
  font-weight: bold;
  padding-bottom: ${pxToRem('10px')};
`;

export const TitleWrapper = styled.div`
  font-size: ${pxToRem('16px')};
  font-weight: normal;
`;

export const ContainerWrapper = styled.div`
  padding: ${pxToRem('10px')};
`;
